module.exports = __webpack_public_path__ + "img/successful_planification.cca62cf0.svg";